import { createSelector } from 'reselect';
import { RequestStatus } from 'types';
import { EddyState } from './types';

const stateSelector = (state): EddyState => state.get('eddy');

export const eddyProjectSelector = createSelector(stateSelector, state =>
  state.get('eddyProject'),
);

export const pollStatusSelector = createSelector(stateSelector, state =>
  state.get('pollStatus'),
);

export const isWaitingForEddyProjectSelector = createSelector(
  pollStatusSelector,
  status => status === RequestStatus.REQUEST,
);

export const eddyProjectCreationProgressPercentageSelector = createSelector(
  eddyProjectSelector,
  state => (state?.progress?.percentMilli ?? 0) / 1000,
);

export const eddyProjectIdSelector = createSelector(
  eddyProjectSelector,
  state => state?.projectId,
);

export const eddyProjectCuidSelector = createSelector(
  eddyProjectSelector,
  state => state?.projectCuid,
);

export const eddyProjectStatusSelector = createSelector(
  eddyProjectSelector,
  state => state?.status,
);
